

// Start script for partner.liquid section

const carousels = document.querySelectorAll('.partnerContainerInner');
const categoriesBtns = document.querySelectorAll('.category-btn');

function updateOptions() {
  carousels.forEach(carousel => {
    let options = {
      prevNextButtons: true,
      pageDots: false,
      wrapAround: true,
      groupCells: 1,
      arrowShape: { x0: 20, x1: 60, y1: 40, x2: 60, y2: 35, x3: 25 }
    };
  
    const partnerLogos = carousel.querySelectorAll('.partnerChild').length;
  
    if (matchMedia('screen and (min-width: 991px)').matches) {
      options.groupCells = partnerLogos >= 4 ? 4 : 1;
    } else if (matchMedia('screen and (min-width: 700px)').matches && matchMedia('screen and (max-width: 990px)').matches) {
      options.groupCells = partnerLogos >= 3 ? 3 : 1;
    } else if (matchMedia('screen and (max-width: 699px)').matches) {
      options.groupCells = 1;
    }
  
    carousel.setAttribute('data-flickity', JSON.stringify(options));
  });
}

updateOptions();
window.addEventListener('resize', updateOptions);

const filterCategories = (event) => {
  const category = event.target.getAttribute('data-category');

  // Remove the active class from all category buttons
  const categoriesBtns = document.querySelectorAll('.category-btn');
  categoriesBtns.forEach((btn) => {
    btn.classList.remove('category-btn--active');
  });

  // Add the active class to the clicked button
  event.target.classList.add('category-btn--active');

  // Show/hide partnerContainerInner based on category
  carousels.forEach((partnerContainerInner) => {
    if (partnerContainerInner.getAttribute('data-partnerCategory') == category) {
      partnerContainerInner.style.display = 'block';
    } else {
      partnerContainerInner.style.display = 'none';
    }
  }); 
};

updateOptions(); 

// Show all carousels first
carousels.forEach((partnerContainerInner) => {
  partnerContainerInner.style.display = 'block';
});

// Set the first category button to active by default, 
// added the if conditional to avoid getting console undefined error on pages where this section isn't available
if (categoriesBtns.length > 0 ) {
categoriesBtns[0].classList.add('category-btn--active');
setTimeout(function() {
  categoriesBtns[0].click();
}, 100); 
}
// the modal part scripts 
document.addEventListener("DOMContentLoaded", function() {
    // Get all partnerChild elements
    const partnerChildElems = document.querySelectorAll(".partnerChild");

    // Create the modal element
    const modal = document.createElement("div");
    modal.classList.add("modal");
    modal.style.display = "none";

    // Create the modal content element
    const modalContent = document.createElement("div");
    modalContent.classList.add("modal-content-outer");
    modal.appendChild(modalContent);

    // Add the modal to the document
    document.body.appendChild(modal);

    // Loop through each partnerChild element
    partnerChildElems.forEach(partnerChild => {
        partnerChild.addEventListener("click", function() {
        // Get the content and button information from the data attributes
        const partnerContent = this.getAttribute('data-partnerContent');
        const partnerChildImage = this.querySelector('img');
        const partnerLogo = partnerChildImage.src;
        const partnerName = this.getAttribute('data-partnerName')
        const partnerBtnLabel = this.getAttribute('data-partnerBtnLabel');
        const partnerBtnLink = this.getAttribute('data-partnerBtnLink');
        
        // Update the modal content with the information
        modalContent.innerHTML = `
            <div class="modal-content br1p4">
            <div class="leftPartnerModal brTlBl"> <img class="brTlBl mA" src=${partnerLogo}> </div>
            <div class="rightPartnerModal pLR16">
                <button class="closeModalBtn"> <svg stroke="currentColor" fill="none" stroke-width="4" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></button>
                <p class="fw7 H3-v2 lh-1p2 mB24"> ${partnerName} </p>
                <p class="rightPartnerModalContent fs15"> ${partnerContent} </p> 
            <a href="${partnerBtnLink}" target="_blank" class="modal-btn Button Button--primary">${partnerBtnLabel}</a>
            </div>
            </div>
        `;
        
        // Show the modal
        modal.style.display = "block";

        // Close the modal when clicking the close button
        modalContent.querySelector(".closeModalBtn").addEventListener("click", function() {
            modal.style.display = "none";
        });
        });
    });

    // Close the modal when clicking outside of it
    window.addEventListener("click", function(event) {
        if (event.target === modalContent) {
        modal.style.display = "none";
        }
    });
});

//***************************

// START script for blog-carousel.liquid section

// ADD event listener to .block divs
const blocks = document.querySelectorAll(".block");
blocks.forEach((block) => {
  block.addEventListener("click", showModal);
});

function showModal(event) {
  // GET data-target value of the clicked div
  const target = event.currentTarget.getAttribute("data-target");
  
  // Find the modal with the same data-target value and display it
  const modal = document.querySelector(`.blogPostsModal[data-target="${target}"]`);
  modal.classList.remove('blogPostsModal-closed');
  modal.style.display = "block";
  document.body.style.overflow = 'hidden';
    
  // There are some span tags that have some inline styling from the blog posts and are showing in the page
  // had to remove them with js instead of going and modifying each one 
  const blogPostsListContentDivs = document.querySelectorAll('.blogPostsListContent');

  blogPostsListContentDivs.forEach(div => {
    const span = div.querySelector('p span');
    if (span) {
      span.removeAttribute('style');
    }
  });

  // Close the modal when clicking the close button, outside and ESC key
  const closeButton = modal.querySelector(".blogPostsModalClose");
  closeButton.addEventListener("click", () => {
    modal.classList.add('blogPostsModal-closed');
    modal.style.display = "none";
    document.body.style.overflow = 'auto';
  });

  modal.addEventListener("click", (event) => {
    if (event.target.classList.contains("blogPostsModal")) {
      modal.style.display = "none";
      document.body.style.overflow = 'auto';
    }
  });

  // const existingVideoContainer = document.querySelector(".blogPostsVideoContainer");
  // if ( !existingVideoContainer ) {
  //   document.addEventListener('keyup', (event) => {
  //     if (event.key === 'Escape') {
  //       modal.style.display = "none";
  //     }
  //   });
  // }
  
}

 // ADD event listener to .blogPostsListInner divs
 const blocksInner = document.querySelectorAll(".blogPostsListInner");
 blocksInner.forEach((block) => {
  if (block.hasAttribute("data-video-id")) {
    block.addEventListener("click", showVideoModal);
  }
 });
 
 function showVideoModal(event) {
   // GET data-video-id value of the clicked div
   const videoId = event.currentTarget.getAttribute("data-video-id");

   // it was creating 2 divs so first we check if a video container already exists, and if it does, remove it
   const existingVideoContainer = document.querySelector(".blogPostsVideoContainer");
   if (existingVideoContainer) {
     existingVideoContainer.parentNode.removeChild(existingVideoContainer);
   }
 
   // Create the blogPostsVideoContainer div and the content
   const videoContainer = document.createElement("div");
   videoContainer.classList.add("blogPostsVideoContainer");

   const videoContainerInner = document.createElement("div");
   videoContainerInner.classList.add("blogPostsVideoContainerInner");
 
   const iframe = document.createElement("iframe");
   iframe.classList.add("bAllSides--transparent", "imgBr", "videoContainerDimensions");
  //  iframe.setAttribute("width", "760");
  //  iframe.setAttribute("height", "415");
   iframe.setAttribute("src", videoId);
   iframe.setAttribute("allow", "picture-in-picture; web-share");
   iframe.setAttribute("allowfullscreen", "");
 
   const closeButton = document.createElement("button");
   closeButton.classList.add("blogPostsVideoClose");
   closeButton.innerHTML = '<svg stroke="currentColor" fill="none" stroke-width="4" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"> <line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>';
 
   videoContainerInner.appendChild(iframe);
   videoContainerInner.appendChild(closeButton);
   videoContainer.appendChild(videoContainerInner);
   
 
   // Append the blogPostsVideoContainer to the body
   document.body.appendChild(videoContainer);

   // Close the video container when close btn, outside and ESC key
   closeButton.addEventListener("click", () => {
    videoContainer.remove()
   });

   videoContainer.addEventListener("click", (event) => {
     if (event.target === videoContainer) {
       videoContainer.remove();
     }
   });

   document.addEventListener('keyup', (event) => {
     if (event.key === 'Escape') {
       videoContainer.remove();
     }
   });
 }


//***************************//

/* sidebar menu shop */

const sidebarShopBtn = document.getElementById('btnMenuShopDrawer');
const sidebarDrawerShop = document.getElementById('sidebar-menu-shop');
const closeSidebarDrawerShop = sidebarDrawerShop?.querySelector('.Drawer__Close');

if (sidebarShopBtn) {
  sidebarShopBtn.addEventListener('click', () => {
    sidebarDrawerShop.ariaHidden="false";
  });
}

if (closeSidebarDrawerShop) {
  closeSidebarDrawerShop.addEventListener('click', () => {
    sidebarDrawerShop.ariaHidden="true";
  });
}



/* ywh tv */

const ywhTvCarrousels = document.querySelectorAll('.ywh-tv-carrousel');
  setTimeout(()=> {
    // ywhTvCarrousels.forEach(el => el.classList.remove('ywh-tv-carrousel--height'))
  }, 4000)


  /* CUSTOM-PRODUCT-CARD.LIQUID -- Gallery block */

  /*
    The script will not execute if no gallery elements are found.
    
    structure of a Gallery Element:
      1- each gallery must have a unique 'data-id' attribute to differentiate between multiple galleries on the same page.
    
      2- Within each gallery, there should be:
        -- radio input elements with the class 'Gallery__ThumbnailInput' for thumbnail selection.
          - these inputs must have an 'id' attribute formatted as "{{ block.id }}-{{ image.id }}". 
          - the 'name' attribute for these inputs should be formatted as "gallery-{{ block.id }}" ensuring that thumbnail selection is grouped by gallery.
        -- a container with the class 'Gallery__CurrentImage' for displaying full-size images.
          - Each image within this container should have an 'id' attribute that matches its corresponding thumbnail's image ID: "{{ image.id }}".
    
    Expected Behavior:
      - when a thumbnail input ('Gallery__ThumbnailInput') is selected (via a 'change' event), the script identifies the corresponding full-size image in the 'Gallery__CurrentImage' container.
      - the 'selected-image' class is added to the identified image
  */
 
  document.addEventListener('DOMContentLoaded', function() {
    const galleries = document.querySelectorAll('.Gallery');

    galleries.forEach(function(gallery) {
      const galleryId = gallery.getAttribute('data-id');
      const thumbnails = gallery.querySelectorAll('.Gallery__ThumbnailInput');
      const allImages = gallery.querySelectorAll('.Gallery__CurrentImage picture img');
  
      thumbnails.forEach(function(thumbnail) {
        thumbnail.addEventListener('change', function() {
          if (thumbnail.checked) {
            allImages.forEach(function(img) {
              const isSelectedImage = thumbnail.id === `${galleryId}-${img.getAttribute('id')}`;
              img.classList.toggle('selected-image', isSelectedImage); 
            });
          }
        });
      });
    });
  });


  // info dropdowns function

  function attachListeners() {
    document.addEventListener('click', function (event) {
        const target = event.target.closest('[data-action="toggle-collapsible"]');
        if (target) {
            toggleCollapsible(event, target);
        }
    });
}

/**
 * Toggle a given collapsible
 */
function toggleCollapsible(event, target) {
    const parentCollapsible = target.closest('.Collapsible');

    // If this is an auto-expand and that it reaches the needed breakpoint, we do nothing
    if (parentCollapsible.classList.contains('Collapsible--autoExpand') && Responsive.matchesBreakpoint('tablet-and-up')) {
        return;
    }

    const isOpen = target.getAttribute('aria-expanded') === 'true';

    if (isOpen) {
        closeCollapsible(parentCollapsible, target);
    } else {
        openCollapsible(parentCollapsible, target);
    }

    // Close any sibling collapsibles
    getSiblings(parentCollapsible).forEach(function (collapsibleToClose) {
        closeCollapsible(collapsibleToClose);
    });

    event.preventDefault();
}

/**
 * Open a given collapsible
 */
function openCollapsible(collapsible) {
    const toggleButton = collapsible.querySelector('.Collapsible__Button');
    const collapsibleInner = collapsible.querySelector('.Collapsible__Inner');

    if (!collapsibleInner || toggleButton.getAttribute('aria-expanded') === 'true') {
        return; // It's already open
    }

    toggleButton.setAttribute('aria-expanded', 'true');
    collapsibleInner.style.height = collapsibleInner.scrollHeight + 'px';
    collapsibleInner.style.overflow = 'visible';

    collapsible.classList.add('is-open');
    collapsibleInner.addEventListener('transitionend', function onTransitionEnd() {
        collapsibleInner.style.height = 'auto'; // Reset height after animation
        collapsibleInner.removeEventListener('transitionend', onTransitionEnd);
    });
}

/**
 * Close a given collapsible
 */
function closeCollapsible(collapsible) {
    const toggleButton = collapsible.querySelector('.Collapsible__Button');
    const collapsibleInner = collapsible.querySelector('.Collapsible__Inner');

    if (!collapsibleInner || toggleButton.getAttribute('aria-expanded') === 'false') {
        return; // It's already closed
    }

    toggleButton.setAttribute('aria-expanded', 'false');
    collapsibleInner.style.height = collapsibleInner.scrollHeight + 'px'; // Set to current height
    requestAnimationFrame(() => {
        collapsibleInner.style.height = '0'; // Collapse to 0 height
    });

    collapsible.classList.remove('is-open');
    collapsibleInner.style.overflow = 'hidden';
}

// Utility function to get siblings
function getSiblings(element) {
    return Array.from(element.parentNode.children).filter(function (child) {
        return child !== element;
    });
}

// Initialize listeners
attachListeners();


window.addEventListener("DOMContentLoaded", () => {
  const descriptionElement = document.querySelector('.CollectionDescription_Text');
  const toggleButton = document.getElementById('toggle-button-collection');

  if (descriptionElement && toggleButton) {
    const viewMore = toggleButton.getAttribute('data-view-more');
    const viewLess = toggleButton.getAttribute('data-view-less');
    const maxHeight = 100; // Adjust height limit

    function toggleDescription() {
      if (descriptionElement.classList.contains("collapsed")) {
        descriptionElement.style.maxHeight = "none";
        descriptionElement.classList.remove("collapsed");
        toggleButton.innerHTML = viewLess;
      } else {
        descriptionElement.style.maxHeight = maxHeight + "px";
        descriptionElement.classList.add("collapsed");
        toggleButton.innerHTML = viewMore;
      }
    }

    // Initialize
    descriptionElement.classList.remove('hide'); // Ensure it becomes visible
    toggleButton.style.display = "block"; // Always show the button
    toggleButton.addEventListener("click", toggleDescription);
  }
});
